import './style.scss';

// ===========================================================================
// Header
// ===========================================================================
export enum ListHeaderCellType {
  textCell = 'listHeader_textCell',
  applyQtyCell = 'listHeader_applyQtyCell',
  quantityCell = 'listHeader_quantityCell',
  amountCell = 'listHeader_amountCell',
  dateCell = 'listHeader_dateCell',
  sentenceCell = 'listHeader_sentenceCell',
  refundCell = 'listHeader_refundCell',
}

type ListHeaderCellProps = {
  type: ListHeaderCellType;
  label?: string;
};

export const ListHeaderCell = (props: ListHeaderCellProps) => {
  const { type, label } = props;
  return <span className={type}>{label}</span>;
};

// ===========================================================================
// Body
// ===========================================================================
export enum ListBodyCellType {
  // listCategoryLabel =  "listCategory listCategory_label"
  textCell = 'listBody_textCell',
  sentenceCell = 'listBody_sentenceCell',
  labelCell = 'listBody_labelCell',
  nameCell = 'listBody_nameCell',
  applyQtyCell = 'listBody_applyQtyCell',
  quantityCell = 'listBody_quantityCell',
  amountCell = 'listBody_amountCell',
  confirmCell = 'listBody_confirmCell',
  dateCell = 'listBody_dateCell',
  checkCell = 'listBody_checkCell',
  refundCell = 'listBody_refundCell',
}

type ListBodyCellProps = {
  type: ListBodyCellType;
  label?: React.ReactNode;
};

export const ListBodyCell = (props: ListBodyCellProps) => {
  const { type, label } = props;
  return <span className={type}>{label}</span>;
};
